var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", { staticClass: "bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid max-w-screen-xl" }, [
        _c("div", { staticClass: "row g-0" }, [
          _c("div", { staticClass: "col ps-4 pt-4" }, [
            _c("h1", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.user.name))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "border-bottom pt-6" },
          [
            _c(
              "v-tabs",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", { key: "profile" }, [_vm._v("Cuenta")]),
                _vm._v(" "),
                _c("v-tab", { key: "contact" }, [
                  _vm._v("Contacto y dirección"),
                ]),
                _vm._v(" "),
                _c("v-tab", { key: "settings" }, [
                  _vm._v("Facturación electrónica"),
                ]),
                _vm._v(" "),
                _c("v-tab", { key: "notifications" }, [
                  _vm._v("Notificaciones"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _vm.tab === 0 ? _c("account") : _vm._e(),
          _vm._v(" "),
          _vm.tab === 1 ? _c("contact") : _vm._e(),
          _vm._v(" "),
          _vm.tab === 2 ? _c("invoice") : _vm._e(),
          _vm._v(" "),
          _vm.tab === 3 ? _c("notifications") : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }